export enum LocalStorageKeysEnum {
  ORDER_OVERVIEW_TABLE_COLUMN_ORDER = "ORDER_OVERVIEW_TABLE_COLUMN_ORDER"
}
